import React, { useState, useEffect } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom';

import { useTranslate, useLanguage } from '../Context/LanguageContext';
import { ReactComponent as Menu } from '../assets/icons/menu.svg'
import { ReactComponent as Close } from '../assets/icons/close.svg'

const MobileNavbar = () => {
    const [isOpen, setOpen] = useState(false)

    const t = useTranslate("navbar")
    const { ForChina, ForRegular, language, setLanguage } = useLanguage()
    const navigate = useNavigate()

    const close = () => setOpen(false)
    const toggle = () => setOpen(prev => !prev)

    const selectLang = (lang) => {
        if ((language === "zh" && lang !== "zh") || (language !== "zh" && lang === "zh")) {
            navigate("/")
            window.scrollTo({ top: 0, left: 0 });
        }
        setLanguage(lang)
        close()
    }

    // Lock background scroll and allow closing with Escape while the overlay is open
    useEffect(() => {
        if (!isOpen) return;

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const handleKey = (event) => {
            if (event.key === 'Escape') close();
        };
        document.addEventListener('keydown', handleKey);

        return () => {
            document.body.style.overflow = prevOverflow;
            document.removeEventListener('keydown', handleKey);
        };
    }, [isOpen]);

    return (
        <>
            <button
                className='mobile-menu-btn'
                aria-label="Menü öffnen"
                aria-expanded={isOpen}
                onClick={toggle}
            >
                <Menu />
            </button>

            <div className={`mobile-overlay ${isOpen ? "open" : ""}`} role="dialog" aria-modal="true">

                <div className='mobile-overlay-top'>
                    <Link to="/" className='mobile-overlay-logo' onClick={close}>
                        <img src="./images/logo3.svg" alt="SINIS" />
                        <p>SINIS</p>
                    </Link>

                    <button className='mobile-overlay-close' aria-label="Menü schließen" onClick={close}>
                        <Close />
                    </button>
                </div>

                <ForRegular>
                    <div className='mobile-overlay-links'>
                        <NavLink onClick={close} to="/invest">{t("invest")}</NavLink>
                        <NavLink onClick={close} to="/purchase">{t("purchase")}</NavLink>
                        <NavLink onClick={close} to="/distribution">{t("distribution")}</NavLink>
                        <NavLink onClick={close} to="/recruitment">{t("professionals")}</NavLink>
                        <NavLink onClick={close} to="/about">{t("about")}</NavLink>
                    </div>
                </ForRegular>

                <ForChina>
                    <div className='mobile-overlay-links'>
                        <NavLink onClick={close} to="/visa-consulting">德国签证与移民</NavLink>
                        <NavLink onClick={close} to="/business">德国商务与投资</NavLink>
                        <NavLink onClick={close} to="/international-trade">中欧国际贸易</NavLink>
                    </div>
                </ForChina>

                <div className='mobile-overlay-footer'>
                    <ForRegular>
                        <NavLink to="/contact" className='mobile-overlay-contact' onClick={close}>
                            {t("contact")}
                        </NavLink>
                    </ForRegular>
                    <ForChina>
                        <NavLink to="/contact" className='mobile-overlay-contact' onClick={close}>
                            联系我们
                        </NavLink>
                    </ForChina>

                    <div className='mobile-overlay-lang'>
                        <button
                            className={`lang-option ${language === "de" ? "active" : ""}`}
                            onClick={() => selectLang("de")}
                        >
                            <img src="./images/germany.webp" alt="" />
                            <span>Deutsch</span>
                        </button>
                        <button
                            className={`lang-option ${language === "en" ? "active" : ""}`}
                            onClick={() => selectLang("en")}
                        >
                            <img src="./images/english.webp" alt="" />
                            <span>English</span>
                        </button>
                        <button
                            className={`lang-option ${language === "zh" ? "active" : ""}`}
                            onClick={() => selectLang("zh")}
                        >
                            <img src="./images/china.webp" alt="" />
                            <span>中文</span>
                        </button>
                    </div>
                </div>

            </div>
        </>
    );
}

export default MobileNavbar;
